import { GetterTree } from 'vuex';
import {rootStore, mainRootState, appointment, user} from "@/store/types";

export type Getters = {
    isSidebarVisible(state: mainRootState): boolean;
    getAppointmentList(state: mainRootState): appointment[];

    getTransition(state: mainRootState): string;
    getBackwardsValue(state: mainRootState): boolean;
    getHistoryCount(state: mainRootState): number;
}

export const getters: GetterTree<mainRootState, rootStore> & Getters = {

    isSidebarVisible(state: mainRootState): boolean {
        return state.sidebarVisible;
    },
    getAppointmentList(state: mainRootState): appointment[] {
        return state.appointments;
    },

    getTransition(state: mainRootState): string {
        return state.transition;
    },
    getBackwardsValue(state: mainRootState): boolean {
        return state.backwards;
    },
    getHistoryCount(state: mainRootState): number {
        return state.historyCounter;
    }
};